// Generated by Melange

import * as Buhta_cabinet__ButtonPrimary from "../../components/html/ButtonPrimary.js";
import * as Buhta_cabinet__EventHandlers from "../../util/EventHandlers.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as QrcodeReact from "qrcode.react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SignDropdownDesktop(Props) {
  let title = Props.title;
  let code = Props.code;
  let onNcaLayerClickOpt = Props.onNcaLayerClick;
  const onNcaLayerClick = onNcaLayerClickOpt !== undefined ? onNcaLayerClickOpt : (function (param) {
      
    });
  const match = React.useState(function () {
    return false;
  });
  const setShowDropdown = match[1];
  const showDropdown = match[0];
  const activatorRef = React.useRef(null);
  const dropdownRef = React.useRef(null);
  Buhta_cabinet__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
    Curry._1(setShowDropdown, (function (param) {
      return false;
    }));
  }));
  return JsxRuntime.jsx(React.Fragment, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Buhta_cabinet__ButtonPrimary.make, {
          title: title,
          onClick: (function (param) {
            Curry._1(setShowDropdown, (function (param) {
              return !showDropdown;
            }));
          }),
          icon: StaticAsset.src("/static/icons/sign.svg"),
          reference: activatorRef
        }),
        JsxRuntime.jsxs("div", {
          ref: dropdownRef,
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  className: "text-center",
                  children: "Подпишите через eGov Mobile"
                }),
                JsxRuntime.jsx(QrcodeReact.QRCodeSVG, {
                  value: "mobileSign:https://buhta.com/mgovSign/" + code,
                  className: "w-36"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("ol", {
                    children: [
                      JsxRuntime.jsx("li", {
                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "inline",
                          children: "Откройте приложение eGov Mobile"
                        })
                      }),
                      JsxRuntime.jsx("li", {
                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "inline",
                          children: "Отсканируйте QR-код"
                        })
                      }),
                      JsxRuntime.jsx("li", {
                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "inline",
                          children: "Подпишите документ"
                        })
                      })
                    ],
                    className: "list-decimal list-inside font-normal text-sm text-gray-medium"
                  }),
                  className: "w-full"
                })
              ],
              className: "border border-gray-light rounded-sm px-4 pt-6 pb-4 w-[304px] space-y-6 flex flex-col items-center"
            }),
            JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                      className: "text-left",
                      children: "NCALayer"
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                      className: "text-asphalt",
                      children: "Подписать с помощью ЭЦП"
                    })
                  ],
                  className: "space-y-1"
                }),
                JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  alt: "key",
                  src: StaticAsset.src("/static/icons/key-gray-24.svg")
                })
              ],
              className: "border border-gray-light rounded-sm px-4 py-2 w-[304px] flex justify-between items-center",
              onClick: (function (param) {
                Curry._1(setShowDropdown, (function (param) {
                  return false;
                }));
                Curry._1(onNcaLayerClick, undefined);
              })
            })
          ],
          className: Cn.fromList({
            hd: "absolute bg-white rounded-sm border border-gray-main shadow-kkms p-2 right-0 top-9 z-10 space-y-2",
            tl: {
              hd: showDropdown ? "" : "hidden",
              tl: /* [] */ 0
            }
          })
        })
      ],
      className: "ml-10 relative"
    })
  });
}

const make = SignDropdownDesktop;

export {
  make,
}
/* Buhta_cabinet__ButtonPrimary Not a pure module */
